module.exports = __webpack_public_path__ + "static/media/soy_icon.230ba43c.png";